import React, { PureComponent } from 'react';
import './Radar.css';
import 'leaflet/dist/leaflet.css';
import PropTypes from 'prop-types';
import L from 'leaflet';
import { baseTiles, radarTiles, suffixUrlTiles } from '../../utils/urls';
import { MINUTES_FOR_NOT_SHOWING_TILES } from '../../utils/globals';
import { DateTime } from 'luxon';
import { getEnvironment } from '../../config/environment';
import { convertToTwoDigitFigures } from '../../utils/utils';

const { BASE_URL } = getEnvironment();

export class Radar extends PureComponent {
    style = {
        left: 0,
        top: 0,
    };

    static propTypes = {
        data: PropTypes.shape({
            dataSistema: PropTypes.string,
            dataUltimaImatge: PropTypes.string,
        }),
        preview: PropTypes.bool,
    };

    render() {
        const { preview } = this.props;
        return (
            <div
                className="Radar mc-leaflet-map"
                id="map-radar"
                style={{ height: !preview ? '100%' : '244px' }}
            />
        );
    }

    componentDidMount() {
        if (document.querySelector('#map-radar')) {
            this.map = L.map('map-radar', {
                center: [41.7, 1.72],
                zoomSnap: 0.5,
                zoom: 6.6,
                maxZoom: 10,
                minZoom: 6.6,
            });
            this.map.setMaxBounds(this.map.getBounds());
        }

        window.addEventListener('resize', () => {
            const zoom = this.calculateZoom();
            this.map.setZoom(zoom);
        });
    }

    componentDidUpdate() {
        if (document.querySelector('#map-radar')) {
            this.generateTileLayer(`${baseTiles}${suffixUrlTiles}`, {}).addTo(
                this.map
            );

            this.generateTileLayer(
                `${radarTiles}${this.getTilesUrlInfix()}${suffixUrlTiles}`,
                {
                    opacity: 0.85,
                    maxNativeZoom: 7,
                    errorTileUrl: `${BASE_URL}images/mapes/NoData.png`,
                }
            ).addTo(this.map);

            const zoom = this.calculateZoom();
            this.map.setZoom(zoom);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handler);
    }

    generateTileLayer(tilesUrl, layerOptions) {
        var newTile = L.tileLayer(tilesUrl, layerOptions);

        newTile.getTileUrl = function(tilePoint) {
            return L.Util.template(
                this._url,
                {
                    z: ('0' + tilePoint.z).slice(-2),
                    x: ('00' + tilePoint.x).slice(-3),
                    y: (
                        '00' +
                        (this._globalTileRange.max.y - tilePoint.y)
                    ).slice(-3),
                },
                this.options
            );
        };

        return newTile;
    }

    getTilesUrlInfix = () => {
        if (this.isRadarDataValid()) {
            const date = DateTime.fromFormat(
                this.props.data.dataUltimaImatge,
                "MM/dd/yyyy h:mm'Z",
                {
                    zone: 'utc',
                }
            );

            const year = date.year;
            const month = convertToTwoDigitFigures(date.month);
            const day = convertToTwoDigitFigures(date.day);
            const hour = convertToTwoDigitFigures(date.hour);
            const minute = convertToTwoDigitFigures(date.minute);

            return `${year}/${month}/${day}/${hour}/${minute}/`;
        }
        console.log(
            `Les dades del radar no són vàlides. Data del servidor: ${
                this.props.data.dataSistema
            }. Data última imatge: ${this.props.data.ultimaImage}`
        );
    };

    isRadarDataValid = () => {
        const { dataUltimaImatge, dataSistema } = this.props.data;
        const dataImatge = DateTime.fromFormat(
            dataUltimaImatge,
            "MM/dd/yyyy h:mm'Z",
            {
                zone: 'utc',
            }
        );
        const dataServidor = DateTime.fromFormat(
            dataSistema,
            "MM/dd/yyyy h:mm'Z",
            {
                zone: 'utc',
            }
        );
        const dataSistemaDate = new Date(dataServidor.toMillis());
        const ultimaImatgeDate = new Date(dataImatge.toMillis());

        // In milliseconds
        const dateThreshold =
            dataSistemaDate - MINUTES_FOR_NOT_SHOWING_TILES * 60 * 1000;

        return ultimaImatgeDate - dateThreshold > 0;
    };

    calculateZoom = () => {
        let zoom = 6.6;
        const w = window.innerWidth;
        const h = window.innerHeight;

        if ((w === 296 && h === 412) || this.props.preview) return zoom;

        if (w > 625 && h > 750) {
            zoom = 8;
            return zoom;
        }

        if (w > 475 && h > 600) {
            zoom = 7.5;
            return zoom;
        }

        if (w > 325 && h > 450) {
            zoom = 7;
            return zoom;
        }

        return zoom;
    };
}



// WEBPACK FOOTER //
// ./src/partials/Radar/Radar.js